import apiConfig from '../../config/apiConfig';
import {setLoading} from '../../../store/action/progressBarAction';
import {addToast} from '../../../store/action/toastAction';
import {toastType} from '../../constants';

export const branchActionType = {
    FETCH_BRANCHES: 'FETCH_BRANCHES',
    ADD_BRANCH: 'ADD_BRANCH',
};

export const fetchBranches = () => async (dispatch) => {
    await apiConfig.get('branches')
        .then((response) => {
            dispatch({ type: branchActionType.FETCH_BRANCHES, payload: response.data.data });
        })
        .catch(({ response }) => {
            dispatch(addToast({ 
                text: response?.data?.message || 'Erreur lors de la récupération des succursales', 
                type: toastType.ERROR 
            }));
        });
};

export const createBranch = (branchData) => async (dispatch) => {
    try {
        const response = await apiConfig.post('branches', branchData);
        dispatch({ type: branchActionType.ADD_BRANCH, payload: response.data.data });
        dispatch(addToast({ text: 'Succursale créée avec succès' }));
        return response.data.data;
    } catch (error) {
        dispatch(addToast({ 
            text: error?.response?.data?.message || 'Erreur lors de la création de la succursale', 
            type: toastType.ERROR 
        }));
        throw error;
    }
};
